import React, { useContext, useEffect, useState } from "react";
import Funcionalidad from "./Funcionalidad";
import Menu2Nivel from "./Menu2Nivel";
import UtilizacionGlobal from "./UtilizacionGlobal.js"
import UtilizacionPusuario from "./UtilizacionPusuario.js"
import { clBasic } from "./general";
import { AppContext } from "./index";
import utilizacionP from "./img/utilizacionP.png";
import utilizacionG from "./img/utilizacionG.png";

export default function Utilizacion() {
  let { usrLogged } = useContext(AppContext);

  const [funcion, setFuncion] = useState("Global");

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = "Utilización";
    document.getElementById("htmlTituloPagS").innerHTML = funcion;
  }, [funcion]);

  if (usrLogged.isLogged)
    return (
      <div id="UTprincipal" style={Sutilizacion}>
        <Menu2Nivel>
          <Funcionalidad setF={setFuncion} filtroIcon={utilizacionP} funcion={"Por usuario"} />
          <Funcionalidad setF={setFuncion} filtroIcon={utilizacionG} funcion={"Global"} />
        </Menu2Nivel>

        <div style={{ width: "90vw" }} >
          {funcion === "Global" && (
            <UtilizacionGlobal />
          )}
          {funcion === "Por usuario" && (
            <UtilizacionPusuario />
          )}
        </div>
      </div>
    );
  else return <div style={{ color: clBasic }}>Debe loguearse, gil!!</div>;
}

const Sutilizacion = {
  width: "100vw",
  height: "90vh",
  display: "flex",
  flexDirection: "row",
};

